module.exports = __webpack_public_path__ + "static/media/ice-mobility-thumbnail.91f63934.png";